import { Decorators, TemplatedDialog } from "@serenity-is/corelib";

@Decorators.registerClass('Watersource.Common.MarketInformationDisclaimerDialog')
@Decorators.panel(false)
export class MarketInformationDisclaimerDialog<P = {}> extends TemplatedDialog<P> {

    protected getDialogOptions() {
        var opt = super.getDialogOptions();
        opt.buttons = [
            {
                text: "Close",
                click: () => {
                    this.setCookie("MarketInformationDisclaimer", "true");
                    this.dialogClose();
                }
            }
        ];

        return opt;
    }

    private setCookie(name: string, val: string) {
        const date = new Date();
        const value = val;

        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    }

    public okClick: () => void;

    protected getTemplate() {
        return `
            <style>
            p {
                font-size: 16px;
                font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
            }
            </style>
            <div style="margin:20px;">

            <div class="title">
                <img src="/Content/site/images/watersource-full-logo-128.png" alt="Watersource Logo" />
            </div>        
        
            <div style="margin-top:10px; margin-bottom: 30px;">
                <h3>Market Information Explorer</h3>
        
                <p>
                    Hello and welcome to making life less complicated!
                </p>
                <p>
                    We want water companies to have a single view of forecasts in all Water Resource Zones, including yours.
                </p>
                <p>
                    No more trawling through different websites to find the data. Add your own market information and soon we will have a free, easy to access solution for all.
                </p>
                <p>
                    You can contact our Head of Water Solutions, Simon Murray by emailing <a href="mailto:simon.murray@wheatleysolutions.co.uk">simon.murray@wheatleysolutions.co.uk</a> if you have a question, he’s on hand to help.
                </p>
            </div>
            

            <div>
                <h3>How to use this Market Information Explorer </h3>
                <p>
                    Look at the main map to see which water companies have data available here
                    and simply click on one to view the Water Resource Zones and the status of each.
                    No more trawling through different websites to find the data. Add your own market information and soon we will have a free, easy to access solution for all.
                </p>
                <p>
                    Click on a zone to show a graph comparing the "Do Nothing" forecast and
                    "WRMP Impact", which is the effect of implementing the Water Resource Management Plan (WRMP).
                </p>
                <p>You can also use the “Get in Touch” button on the graph to contact the water company too.</p>
            </div>
        </div>
        `;
    }
}
